import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import BrandContact from '@/components/BrandContact';
import BrandsSection from '@/components/BrandsSection';
import AnimatedBackground from '@/components/AnimatedBackground';

const AboutPage = () => {
  const t = {
    title: 'About Us',
    description: 'With our offices in Istanbul and Dubai, we offer specialized Social Media Marketing and Corporate Event Management services to our corporate clients. We approach your business with a professional perspective, understand your corporate language, and work to help your brand achieve its goals. While doing all this, we manage the processes on your behalf with full transparency to ensure the most efficient use of your budget.',
    brandsTitle: 'Brands We Work With',
    brandsDescription: 'We are proud of the brands we grow together with. We develop special strategies for each of them and create a strong presence in the digital world.',
  };

  return (
    <div className="min-h-screen bg-black relative flex flex-col">
      <AnimatedBackground />
      <div className="relative z-10 flex flex-col min-h-screen">
        <Navbar />
        
        {/* About Content */}
        <div className="px-4 pt-32 pb-4 bg-black bg-opacity-75">
          <div className="max-w-4xl mx-auto">
            {/* Title with slide-in animation */}
            <div className="text-center mb-6 animate-slide-in-left">
              <h1 className="text-3xl md:text-4xl text-white mb-6 font-bold">
                {t.title}
              </h1>
              <p className="text-base md:text-lg text-[#FFDD59] leading-relaxed">
                {t.description}
              </p>
            </div>
          </div>
        </div>

        {/* Powered by Persona Ajans heritage section */}
        <div className="px-4 py-8 bg-black bg-opacity-75">
          <div className="max-w-4xl mx-auto">
            <section className="my-8 text-center md:text-left">
              <h2 className="text-[#FFDD59] text-2xl font-semibold mb-4">
                Backed by a Decade of Experience
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                Persona is the UAE & GCC arm of{' '}
                <strong className="text-white">Persona Ajans</strong>, Turkey's leading
                mom-influencer marketing agency since 2014. With over a decade of experience
                connecting brands with authentic mom voices, we now bring this expertise to the
                United Arab Emirates and the broader Gulf region.
              </p>
              <a
                href="https://personaajans.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#FFDD59] hover:text-yellow-300 transition-colors"
                data-testid="about-persona-ajans-link"
              >
                Visit Persona Ajans
                <span>→</span>
              </a>
            </section>
          </div>
        </div>

        {/* Brands Section Header */}
        <div className="px-4 py-8 bg-black bg-opacity-75">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-6 animate-slide-in-left">
              <h2 className="text-2xl md:text-3xl text-white mb-4 font-bold">
                {t.brandsTitle}
              </h2>
              <p className="text-base md:text-lg text-[#FFDD59] leading-relaxed max-w-3xl mx-auto">
                {t.brandsDescription}
              </p>
            </div>
          </div>
        </div>

        {/* Brands Section */}
        <BrandsSection />

        {/* Contact Form */}
        <BrandContact />

        <Footer />
      </div>
    </div>
  );
};

export default AboutPage;
